export const INITIAL_LOAD = 'INITIAL_LOAD';
export const PRIMARY_NAV_CLICK = 'PRIMARY_NAV_CLICK';

export const PROFILE = 'PROFILE';
export const GENERAL = 'GENERAL';
export const DELTA = 'DELTA';
export const RESULTS = 'RESULTS';

export const PROFILE_OPTION_SELECT = 'PROFILE_OPTION_SELECT';
export const GENERAL_OPTION_SELECT = 'GENERAL_OPTION_SELECT';

export const SECONDARY_NAV_NEXT_CLICK = 'SECONDARY_NAV_NEXT_CLICK';
export const SECONDARY_NAV_PREVIOUS_CLICK = 'SECONDARY_NAV_PREVIOUS_CLICK';

export const DELTA_OPTION_SELECT = 'DELTA_OPTION_SELECT';

export const NONE = 'NONE';

export const SEGMENT = 'segment';
export const ROLE = 'role';
export const REGION = 'region';

export const DATA = 'DATA';
export const ENTERPRISE = 'ENTERPRISE';
export const LEADERSHIP = 'LEADERSHIP';
export const TARGET = 'TARGET';
export const ANALYSTS = 'ANALYSTS';
export const TECHNOLOGY = 'TECHNOLOGY';
export const TECHNIQUES = 'TECHNIQUES';

export const QUESTION0 = 'question0';
export const QUESTION1 = 'question1';
export const QUESTION2 = 'question2';
export const QUESTION3 = 'question3';
export const QUESTION4 = 'question4';

export enum DELTA_OPTIONS {
    DATA,
    ENTERPRISE,
    LEADERSHIP,
    TARGET,
    ANALYSTS,
    TECHNOLOGY,
    TECHNIQUES
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/constants/index.ts